import { VerifyEmailService } from './service/verify-email.service';
import { LocalStorageService } from '../common-service/local-storage/local-storage.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-verify-email',
  templateUrl: './verify-email.component.html',
  styleUrls: ['./verify-email.component.scss']
})
export class VerifyEmailComponent implements OnInit {

  isEmailVerificationError = false;
  verificationErrorMessage = '';

  constructor(private activetedRoute: ActivatedRoute,
              private verifyEmailService: VerifyEmailService,
              private spinnerService: NgxSpinnerService,
              private router: Router,
              private localStorageService: LocalStorageService) { }

  ngOnInit() {

    let customerId = this.activetedRoute.snapshot.params.customerId;
    let verificationCode = this.activetedRoute.snapshot.params.verificationCode;

    console.log('Verification Code : ' +verificationCode);
    this.verifyEmail(customerId, verificationCode);
  }

  verifyEmail(customerId, verificationCode) {

      let verifyEmailObject = {customerId: customerId, verificationCode: verificationCode};

      console.log(verifyEmailObject);
      this.spinnerService.show();

     this.verifyEmailService.verifyEmail(verifyEmailObject).subscribe(response => {
        let status = response.code;
        console.log(response);
        if (status === '200' || status === 200) {
             this.localStorageService.removeCustomerId();
             this.localStorageService.removeUserType();
             this.localStorageService.saveCustomerId(customerId);
             this.localStorageService.saveUserType("NATIVE_USER");
             this.verificationErrorMessage = 'Congratulations! Your account is now ready for use. '+
             'Please check your registered email for Executive Eye login details';
            this.spinnerService.hide();
            //this.router.navigate(['subscription-plans']);
            this.router.navigate(['signup-success']);

        } else if(status === '106' || status === 106) {
            this.isEmailVerificationError = true;
            this.verificationErrorMessage = 'Congratulations! Your account is now ready for use. '+
               'Please check your registered email for Executive Eye login details';
           this.spinnerService.hide();
        } else if(status === '103' || status === '115' || status === '123') {
            this.isEmailVerificationError = true;
            this.verificationErrorMessage = 'Oh snap! Your email verification link is not valid.';
           this.spinnerService.hide();
        } else if (status === '111' ) {
               this.isEmailVerificationError = true;
               this.verificationErrorMessage = 'This email verification link has already been used.';
        } else {
               this.spinnerService.hide();
               this.isEmailVerificationError = true;
               this.verificationErrorMessage  = 'Oh snap!Your email verification link is not valid.';
        }
    },
      err => {
        console.log(err);
           this.spinnerService.hide();
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/verify-email/verify-email.component.ts